<template>
  <div class="TJDetailMenu">
    <div
      :class="[
        {
          'topBorder': item.topBorder == true,
          'rightBorder': item.rightBorder == false,
          'bottomBorder': item.bottomBorder == false,
          'absorbance': item.type != null
        },
        'box',
      ]"
      v-for="(item, index) of dataList"
      :key="index"
      :style="'width:' + item.width"
    >
      <p >{{ item.name }}:</p>
      <p>{{ item.value == null ? '-' : item.value }}</p>
    </div>
  </div>
</template> 
<script>
  export default {
    props: ['dataList'],
  }
</script>
<style lang="scss" scoped>
.TJDetailMenu {
  min-height: 80px;
  background-color: #fff;
  border-radius: 5px;
  padding: 0 5px;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  .box {
    width: 33%;
    border-right: 1px solid $border-color;
    box-sizing: border-box;
    padding: 12px 0 0 12px;
    height: 70px;
    border-bottom: 1px solid $border-color;
    p:nth-child(1) {
      color: #999999;
      font-size: 18px;
      margin-bottom: 5px;
    }
    p:nth-child(2) {
      margin-top: 5px;
      font-size: 18px;
      color: #333333;
    }
  }

  .box:nth-last-child(1) {
    border-right: none;
  }
  .topBorder {
    border-top: 1px solid $border-color;
  }
  .bottomBorder {
    border-bottom: none !important;
  }
  .rightBorder {
    border-right: none;
  }
  .absorbance {
    height: 90px;
  }
}


</style>